/**
 * Module-level store for the current user's email and active tenant.
 * Set by UserContext after loading. Read by api.service to send the
 * X-Goog-Authenticated-User-Email and X-Tenant headers on requests.
 */
let _email: string | null = null;
let _tenant: string | null = null;

export function setCurrentUserEmail(email: string | null): void {
  _email = email;
}

/** Returns the IAP-formatted header value, or null if no user. */
export function getIapEmailHeader(): string | null {
  if (!_email) return null;
  return `accounts.google.com:${_email}`;
}

/**
 * Tenant activo (slug). Solo lo usa un superadmin de Cubicup para "entrar
 * como" un tenant concreto; un usuario normal lo deja en null y el backend
 * resuelve su tenant por su email.
 */
export function setActiveTenant(slug: string | null): void {
  _tenant = slug;
}

export function getActiveTenant(): string | null {
  return _tenant;
}

/**
 * Cabeceras de identidad IAP + tenant activo para las peticiones al backend.
 * Fuente única de verdad para todo el frontend (api.service y páginas).
 */
export function buildAuthHeaders(extra: Record<string, string> = {}): Record<string, string> {
  const headers: Record<string, string> = { ...extra };
  const iap = getIapEmailHeader();
  if (iap) headers['X-Goog-Authenticated-User-Email'] = iap;
  if (_tenant) headers['X-Tenant'] = _tenant;
  return headers;
}
